import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";

import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getUmspannwerke,
  selectUmspannwerkListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuellesUmspannwerk,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuellesUmspannwerk,
  createUmspannwerk,
  updateUmspannwerk,
  setName,
  setKuerzel,
  setBreitengrad,
  setLaengengrad,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteUmspannwerk,
  setError,
  resetError,
  selectError,
  umspannwerkDummy,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./umspannwerkeSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { umspannwerk } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";

export const Umspannwerke: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);


  useEffect(() => {
    dispatch(getUmspannwerke())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    umspannwerkSelectListe: umspannwerk[] = useAppSelector(selectUmspannwerkListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuellesUmspannwerk: umspannwerk = useAppSelector(selectAktuellesUmspannwerk),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'kuerzel', headerName: 'Kuerzel', flex: 2 },
    { field: 'breitengrad', headerName: 'Breitengrad', flex: 2, filterable: false },
    { field: 'laengengrad', headerName: 'Laengengrad', flex: 2, filterable: false }
  ]

  function printTableUmspannwerk(data: umspannwerk[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            getRowId={(row) => row.name}
            columns={dataGridCols2}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let uw = umspannwerkDummy;
              const currentUw = data.find(uws => uws.name == (param.row.name))
              if (currentUw)
                uw = currentUw;
              if (!editEntry) dispatch(updateAktuellesUmspannwerk(uw));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createUmspannwerk(aktuellesUmspannwerk)) : dispatch(updateUmspannwerk(aktuellesUmspannwerk)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuellesUmspannwerk.name == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteUmspannwerk(aktuellesUmspannwerk));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>
          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuellesUmspannwerk.zugeordnet ?
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(true)}
              color="secondary"
              className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
            >
              {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
            </Button>
            : ""}
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Umspannwerk löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das Umspannwerk "' +
                  aktuellesUmspannwerk.name +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                color="secondary"
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
              >
                Löschen
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }



  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4} >
              <Grid item container xs={12}>
                <Grid item md={3}>
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neues Umspannwerk anlegen" : "Bearbeiten von Umspannwerk: " + aktuellesUmspannwerk.name}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="umspannwerk-name"
                    disabled={newEntry ? false : true}
                    label="Name"
                    error={validate(dispatch, setError, resetError, aktuellesUmspannwerk.name, "name")}
                    helperText={validateHelper(aktuellesUmspannwerk.name)}
                    variant="outlined"
                    onChange={(event) => dispatch(setName(event.target.value))}
                    value={aktuellesUmspannwerk.name}
                  />
                </FormControl>
              </Grid>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="umspannwerk-kuerzel"
                    disabled={editEntry ? false : true}
                    label="Kürzel"
                    error={validate(dispatch, setError, resetError, aktuellesUmspannwerk.kuerzel, "kuerzel")}
                    helperText={validateHelper(aktuellesUmspannwerk.kuerzel)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKuerzel(event.target.value))}
                    value={aktuellesUmspannwerk.kuerzel ? aktuellesUmspannwerk.kuerzel : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="umspannwerk-laengengrad"
                    disabled={editEntry ? false : true}
                    label="Längengrad"
                    type="number"
                    error={validate(dispatch, setError, resetError, aktuellesUmspannwerk.laengengrad.toString(), "laengengrad")}
                    helperText={validateHelper(aktuellesUmspannwerk.laengengrad.toString())}
                    variant="outlined"
                    onChange={(event) => dispatch(setLaengengrad(Number(event.target.value)))}
                    value={aktuellesUmspannwerk.laengengrad}
                  />
                </FormControl>
              </Grid>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="umspannwerk-breitengrad"
                    disabled={editEntry ? false : true}
                    label="Breitengrad"
                    type="number"
                    error={validate(dispatch, setError, resetError, aktuellesUmspannwerk.breitengrad.toString(), "breitengrad")}
                    helperText={validateHelper(aktuellesUmspannwerk.breitengrad.toString())}
                    variant="outlined"
                    onChange={(event) => dispatch(setBreitengrad(Number(event.target.value)))}
                    value={aktuellesUmspannwerk.breitengrad}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="umspannwerk-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuellesUmspannwerk.kommentar, "kommentar")}
                    helperText={validateHelper(aktuellesUmspannwerk.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuellesUmspannwerk.kommentar ? aktuellesUmspannwerk.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Umspannwerke Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableUmspannwerk(umspannwerkSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
